import { PropsWithChildren } from "react";

import { HTMLMotionProps, Variants } from "@enkor/framer-motion";

import { CloseIcon } from "@enkor/design/icons";
import { grayScale } from "@enkor/design/colors";

import * as S from "./BaseBottomSheet.style";

const sheetVariants: Variants = {
  hidden: { y: "100%", opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.4, ease: [0.05, 0.7, 0.1, 1.0] },
  },
  exit: {
    y: "100%",
    opacity: 0,
    transition: { duration: 0.2, ease: [0.3, 0.0, 0.8, 0.15] },
  },
};

type BaseBottomSheetProps = {
  headerTitle?: string;
  onClose?: () => void;
  setting?: S.BottomSheetSettingType;
  closeBtnType?: "text" | "icon";
} & HTMLMotionProps<"div">;

const BaseBottomSheet = ({
  headerTitle,
  onClose,
  setting,
  children,
  closeBtnType = "text",
  ...props
}: PropsWithChildren<BaseBottomSheetProps>) => {
  return (
    <S.BottomSheetContainer
      key={`${headerTitle}-base-bottom-sheet`}
      variants={sheetVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      {...(setting || {})}
      {...props}
    >
      {headerTitle && (
        <S.BottomSheetHeader>
          <S.HeaderTitle name="m">{headerTitle || ""}</S.HeaderTitle>
          {onClose && (
            <S.CloseButton type="button" onClick={onClose}>
              {closeBtnType === "text" ? (
                "Cancel"
              ) : (
                <CloseIcon strokeColor={grayScale.white} />
              )}
            </S.CloseButton>
          )}
        </S.BottomSheetHeader>
      )}
      {children}
    </S.BottomSheetContainer>
  );
};

export default BaseBottomSheet;
